(function() {
  'use strict';
  
  // Wait for dependencies to load
  function initPCBuilder() {
    console.log('initPCBuilder called');
    console.log('React:', typeof React);
    console.log('ReactDOM:', typeof ReactDOM);
    
    if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
      console.log('Dependencies not ready, retrying...');
      setTimeout(initPCBuilder, 50);
      return;
    }
    
    console.log('All dependencies loaded!');
    
    const e = React.createElement;
    const F = React.Fragment;
    const { useState } = React;
    
    // Simple icon components using SVG
    const ChevronRight = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('polyline', { points: '9 18 15 12 9 6' })
    );
    const ChevronLeft = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('polyline', { points: '15 18 9 12 15 6' })
    );
    const Check = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('polyline', { points: '20 6 9 17 4 12' })
    );
    const Cpu = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('rect', { x: 4, y: 4, width: 16, height: 16, rx: 2, ry: 2 }),
      e('rect', { x: 9, y: 9, width: 6, height: 6 }),
      e('line', { x1: 9, y1: 1, x2: 9, y2: 4 }),
      e('line', { x1: 15, y1: 1, x2: 15, y2: 4 }),
      e('line', { x1: 9, y1: 20, x2: 9, y2: 23 }),
      e('line', { x1: 15, y1: 20, x2: 15, y2: 23 }),
      e('line', { x1: 20, y1: 9, x2: 23, y2: 9 }),
      e('line', { x1: 20, y1: 14, x2: 23, y2: 14 }),
      e('line', { x1: 1, y1: 9, x2: 4, y2: 9 }),
      e('line', { x1: 1, y1: 14, x2: 4, y2: 14 })
    );
    const Monitor = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('rect', { x: 2, y: 3, width: 20, height: 14, rx: 2, ry: 2 }),
      e('line', { x1: 8, y1: 21, x2: 16, y2: 21 }),
      e('line', { x1: 12, y1: 17, x2: 12, y2: 21 })
    );
    const HardDrive = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('line', { x1: 22, y1: 12, x2: 2, y2: 12 }),
      e('path', { d: 'M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z' }),
      e('line', { x1: 6, y1: 16, x2: 6.01, y2: 16 }),
      e('line', { x1: 10, y1: 16, x2: 10.01, y2: 16 })
    );
    const Zap = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('polygon', { points: '13 2 3 14 12 14 11 22 21 10 12 10 13 2' })
    );
    const Box = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('path', { d: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' }),
      e('polyline', { points: '3.27 6.96 12 12.01 20.73 6.96' }),
      e('line', { x1: 12, y1: 22.08, x2: 12, y2: 12 })
    );
    const Fan = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('circle', { cx: 12, cy: 12, r: 2 }),
      e('path', { d: 'M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83' })
    );
    const Wifi = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('path', { d: 'M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0' }),
      e('line', { x1: 12, y1: 20, x2: 12.01, y2: 20 })
    );
    const FileCheck = () => e('svg', { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
      e('path', { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }),
      e('polyline', { points: '14 2 14 8 20 8' }),
      e('polyline', { points: '9 15 11 17 15 13' })
    );

    const colors = {
      bg: '#121212',
      cardBg: '#1E1C1F',
      text: '#F3F4F6',
      textLight: '#E5E7EB',
      textMuted: '#9CA3AF',
      primary: '#D78650',
      primaryHover: '#E89A6A',
      border: '#334155',
      borderHover: '#475569',
      borderActive: '#D78650',
      success: '#10B981',
      error: '#EF4444'
    };

    const PCBuilder = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [config, setConfig] = useState({
      cpu: null,
      gpu: null,
      ram: null,
      storage: [],
      motherboard: null,
      psu: null,
      case: null,
      cooling: null,
      wifi: false,
      rgb: false,
      warranty: false,
      peripherals: false,
      os: false
    });

    const cpuOptions = [
      { id: 'r5-5600', name: 'AMD Ryzen 5 5600', price: 190, cores: '6-Core', desc: 'Great for gaming & productivity', socket: 'AM4' },
      { id: 'r5-5600x', name: 'AMD Ryzen 5 5600X', price: 210, cores: '6-Core', desc: 'Great for gaming & productivity', socket: 'AM4' },
      { id: 'r7-5700x', name: 'AMD Ryzen 7 5700X', price: 299, cores: '8-Core', desc: 'Excellent multi-tasking', socket: 'AM4' },
      { id: 'r7-7800x3d', name: 'AMD Ryzen 7 7800X3D', price: 690, cores: '8-Core', desc: 'Best gaming CPU', socket: 'AM5' },
      { id: 'r9-9800x3d', name: 'AMD Ryzen 9 9800X3D', price: 860, cores: '8-Core', desc: 'Ultimate gaming performance', socket: 'AM5' },
      { id: 'r9-9950x3d', name: 'AMD Ryzen 9 9950X3D', price: 1160, cores: '16-Core', desc: 'Ultimate gaming & media creation performance', socket: 'AM5' },
      { id: 'i5-12400f', name: 'Intel Core i5-12400F', price: 210, cores: '6-Core', desc: 'Solid gaming performance', socket: 'LGA1700' },
      { id: 'i7-12700k', name: 'Intel Core i7-12700K', price: 680, cores: '12-Core', desc: 'High-end performance', socket: 'LGA1700' },
      { id: 'i7-14700k', name: 'Intel Core i7-14700K', price: 659, cores: '20-Core', desc: 'Extreme performance', socket: 'LGA1700' }
    ];

    const gpuOptions = [
      { id: 'rtx-5050', name: 'GeForce RTX 5050 8GB', price: 480, tier: 'Budget', desc: 'For general use and light 3D software' },
      { id: 'rx-7600', name: 'Radeon RX 7600 EVO OC Edition 8GB', price: 380, tier: 'Budget', desc: '1080p gaming' },
      { id: 'rtx-5060', name: 'GeForce RTX 5060 8GB', price: 680, tier: 'Budget', desc: 'Latest 1080p gaming' },
      { id: 'rtx-5060-ti', name: 'GeForce RTX 5060 Ti 16GB', price: 849, tier: 'Mid-Range', desc: '1440p ready' },
      { id: 'rtx-5070', name: 'GeForce RTX 5070 12GB', price: 1080, tier: 'Mid-Range', desc: '1440p gaming' },
      { id: 'rtx-5070-ti', name: 'GeForce RTX 5070 Ti 16GB', price: 1680, tier: 'High-End', desc: 'High settings 1440p gaming & Productivity' },
      { id: 'rx-9060-xt', name: 'Radeon RX 9060 XT 16GB', price: 690, tier: 'Mid-Range', desc: '1440p gaming' },
      { id: 'rx-9070-xt', name: 'Radeon RX 9070 XT 16GB', price: 1350, tier: 'High-End', desc: '1440p/VR gaming' },
      { id: 'rtx-5080', name: 'GeForce RTX 5080 OC Edition, 16GB  ', price: 2399, tier: 'High-End', desc: '4k gaming/VR/Local AI' },
      { id: 'rtx-5090', name: 'GeForce RTX 5090 OC Edition, 32GB ', price: 6200, tier: 'Top-End', desc: '4k gaming/VR/Local AI' }
    ];

    const ramOptions = [
      { id: 'ram-16gb-ddr4', name: '16GB DDR4 3200MHz', price: 280, type: 'DDR4', desc: 'Standard gaming' },
      { id: 'ram-32gb-ddr4', name: '32GB DDR4 3200MHz', price: 495, type: 'DDR4', desc: 'Heavy multitasking' },
      { id: 'ram-16gb-ddr5', name: '16GB DDR5 6000MHz', price: 550, type: 'DDR5', desc: 'Latest standard' },
      { id: 'ram-32gb-ddr5', name: '32GB DDR5 6000MHz', price: 840, type: 'DDR5', desc: 'High performance' },
      { id: 'ram-64gb-ddr5', name: '64GB DDR5 6000MHz', price: 1680, type: 'DDR5', desc: 'Professional workload' },
      { id: 'ram-128gb-ddr5', name: '128GB DDR5 6000MHz', price: 3180, type: 'DDR5', desc: 'Simulation & Rendering' }
    ];

    const storageOptions = [
      { id: '4TB-HDD', name: '4TB HDD 3.5in SATA', price: 240, speed: '5400RPM', desc: 'OS + lots of games and media' },
      { id: '8TB-HDD', name: '8TB HDD 3.5in SATA', price: 390, speed: '7200RPM', desc: 'OS + large libraries of media and games' },
      { id: 'ssd-500gb', name: '500GB NVMe SSD', price: 230, speed: 'PCIe 4.0', desc: 'OS + few games' },
      { id: 'ssd-1tb', name: '1TB NVMe SSD', price: 270, speed: 'PCIe 4.0', desc: 'OS + many games' },
      { id: 'ssd-2tb', name: '2TB NVMe SSD', price: 395, speed: 'PCIe 4.0', desc: 'Large game/media library' },
      { id: 'ssd-4tb', name: '4TB NVMe SSD', price: 680, speed: 'PCIe 4.0', desc: 'Massive storage' }
    ];

    const caseOptions = [
      { id: 'case-budget', name: 'Montech Air 100 ARGB', price: 130, type: 'Mid Tower - Black', desc: '2x USB 3.0, 1x HD Audio, 4x 120mm ARGB Fans and Controller Pre-Installed, Ultra-Minimalist Design, Super Fine Mesh Front Panel' },
      { id: 'case-budget2', name: 'Montech Air 100 ARGB', price: 130, type: 'Mid Tower - White', desc: '2x USB 3.0, 1x HD Audio, 4x 120mm ARGB Fans and Controller Pre-Installed, Ultra-Minimalist Design, Super Fine Mesh Front Panel' },
      { id: 'case-mid', name: 'Antec CX500M', price: 145, type: 'Mid Tower - Black', desc: '2x USB 3.0, 1x USB-C 3.2, HD Audio, 2x 120mm ARGB Reverse and 1x 120mm ARGB Fans, Panoramic 270 Degree View' },
      { id: 'case-mid2', name: 'Antec CX500M', price: 145, type: 'Mid Tower - White', desc: '2x USB 3.0, 1x USB-C 3.2, HD Audio, 2x 120mm ARGB Reverse and 1x 120mm ARGB Fans, Panoramic 270 Degree View' },
      { id: 'case-mid3', name: 'NZXT H9 Flow', price: 460, type: 'Mid Tower - Black', desc: 'High-Airflow Perforated Top Panel Tempered Glass Front & Side Panels, 1x USB-C 3.2, 2x USB-A 3.2, HD Audio, 3x F140Q Fans, 1x F120 Quiet Airflow Fans' },
      { id: 'case-mid4', name: 'NZXT H9 Flow', price: 460, type: 'Mid Tower - White', desc: 'High-Airflow Perforated Top Panel Tempered Glass Front & Side Panels, 1x USB-C 3.2, 2x USB-A 3.2, HD Audio, 3x F140Q Fans, 1x F120 Quiet Airflow Fans' },
      { id: 'case-premium', name: 'Corsair FRAME 4000D RS', price: 290, type: 'Mid Tower - Black', desc: 'USB 3.2 Gen 2 Type-C Port, 2x USB 3.2 Gen 1 Type-A ports, and a combination audio/microphone jack' },
      { id: 'case-premium2', name: 'Corsair FRAME 5000D RS', price: 390, type: 'Mid Tower - Black', desc: '1x USB-C 3.2 Gen 2, 4x USB-A 3.2 Gen 1, HD Audio' },
      { id: 'case-premium3', name: 'Corsair AIR 5400', price: 465, type: 'Mid Tower - Black', desc: '2x USB-A 3.2, 1x USB-C 3.2, HD Audio, 3x 120mm RS120R ARGB Fans Pre-Installed' },
      { id: 'case-premium4', name: 'Corsair 6500X Obsidian Aluminium', price: 435, type: 'Mid Tower - Black', desc: '4x USB 3.2 Type-A, 1x USB 3.2 Type-C, HD Audio, Unobstructed View with Tempered Glass Side and Front Panels, Support for iCUE LINK' },
      { id: 'case-premium4', name: 'Corsair 6500X', price: 355, type: 'Mid Tower - White', desc: '4x USB-A 3.2 Gen 1, 1x USB-C 3.2 Gen 2, HD Audio, Dual Chamber Design, Supports iCUE LINK Systems' },
      { id: 'case-high', name: 'Lian Li O11 Dynamic EVO', price: 440, type: 'Mid Tower', desc: '4x USB 3.0, 1x USB Type C, HD Audio, Reversible Frame, Optimized GPU Bracket Design, Removable Front Pilar, Front ARGB Strip' }
    ];

    const coolingOptions = [
      { id: 'stock', name: 'Stock CPU Cooler', price: 0, type: 'Air', desc: 'Included with CPU' },
      { id: 'tower', name: 'Tower Air Cooler', price: 160, type: 'Air', desc: 'Better cooling' },
      { id: 'deepcool', name: 'DeepCool CPU Cooler', price: 360, type: 'Air', desc: 'Suitable for heavy use' },
      { id: 'noctua', name: 'Noctua NH-D12L CPU Cooler', price: 260, type: 'Air', desc: 'Premium quality CPU cooler' },
      { id: 'noctua1', name: 'Noctua NH-D15 chromax.black CPU Cooler', price: 360, type: 'Air', desc: 'Premium quality CPU cooler Black' },
      { id: 'aio-240', name: '240mm AIO Liquid', price: 320, type: 'Liquid', desc: 'Quiet & cool' },
      { id: 'aio-360', name: '360mm AIO Liquid', price: 459, type: 'Liquid', desc: 'Maximum cooling' }
    ];

    const steps = [
      { number: 1, title: 'CPU', icon: Cpu, key: 'cpu' },
      { number: 2, title: 'GPU', icon: Monitor, key: 'gpu' },
      { number: 3, title: 'RAM', icon: Zap, key: 'ram' },
      { number: 4, title: 'Storage', icon: HardDrive, key: 'storage' },
      { number: 5, title: 'Case', icon: Box, key: 'case' },
      { number: 6, title: 'Cooling', icon: Fan, key: 'cooling' },
      { number: 7, title: 'Extras', icon: Wifi, key: 'extras' },
      { number: 8, title: 'Review', icon: FileCheck, key: 'review' }
    ];

    const getMotherboard = () => {
      if (!config.cpu) return null;
      const cpu = cpuOptions.find(c => c.id === config.cpu);
      
      if (cpu.socket === 'AM4') return { name: 'B550 Motherboard', price: 190 };
      else if (cpu.socket === 'AM5') return { name: 'B650 Motherboard', price: 340 };
      else if (cpu.socket === 'LGA1700') return { name: 'B760 Motherboard', price: 400 };
      return null;
    };

    const getPSU = () => {
      if (!config.gpu) return { name: 'Corsair 850W PSU', price: 230 };
      
      const gpu = gpuOptions.find(g => g.id === config.gpu);
      if (gpu.tier === 'Budget') return { name: 'MSI 650W PSU', price: 132 };
      if (gpu.tier === 'Mid-Range') return { name: 'Corsair 850W PSU', price: 230 };
      if (gpu.tier === 'High-End') return { name: 'Corsair 1000W PSU', price: 300 };
      if (gpu.tier === 'Top-End') return { name: 'Corsair 1200W PSU', price: 550 };
      return { name: '1000W PSU', price: 300 };
    };

    const toggleStorage = (id) => {
      setConfig(prev => ({
        ...prev,
        storage: prev.storage.includes(id)
          ? prev.storage.filter(s => s !== id)
          : [...prev.storage, id]
      }));
    };

    const calculateTotal = () => {
      if (currentStep < 8) return 0;
      
      let total = 0;
      
      if (config.cpu) {
        const cpu = cpuOptions.find(c => c.id === config.cpu);
        total += cpu.price;
      }
      
      if (config.gpu) {
        const gpu = gpuOptions.find(g => g.id === config.gpu);
        total += gpu.price;
      }
      
      if (config.ram) {
        const ram = ramOptions.find(r => r.id === config.ram);
        total += ram.price;
      }
      
      config.storage.forEach(storageId => {
        const storage = storageOptions.find(s => s.id === storageId);
        if (storage) total += storage.price;
      });
      
      if (config.case) {
        const caseItem = caseOptions.find(c => c.id === config.case);
        total += caseItem.price;
      }
      
      if (config.cooling) {
        const cooling = coolingOptions.find(c => c.id === config.cooling);
        total += cooling.price;
      }
      
      const mobo = getMotherboard();
      if (mobo) total += mobo.price;
      
      const psu = getPSU();
      if (psu) total += psu.price;
      
      if (config.wifi) total += 59;
      if (config.rgb) total += 159;
      if (config.warranty) total += 399;
      if (config.peripherals) total += 259;
      if (config.os) total += 0;
      
      return Math.round(total);
    };

    const getCurrentStepKey = () => {
      const step = steps.find(s => s.number === currentStep);
      return step ? step.key : '';
    };

    const canProceed = () => {
      const stepKey = getCurrentStepKey();
      
      switch(stepKey) {
        case 'cpu': return config.cpu !== null;
        case 'gpu': return config.gpu !== null;
        case 'ram': return config.ram !== null;
        case 'storage': return config.storage.length > 0;
        case 'case': return config.case !== null;
        case 'cooling': return config.cooling !== null;
        case 'extras': return true;
        case 'review': return true;
        default: return false;
      }
    };

    const handleNext = () => {
      if (currentStep < steps.length) {
        setCurrentStep(currentStep + 1);
        window.scrollTo(0, 0);
      }
    };

    const handleBack = () => {
      if (currentStep > 1) {
        setCurrentStep(currentStep - 1);
        window.scrollTo(0, 0);
      }
    };

    const renderOptionCard = (option, isSelected, onClick, showPrice = true) => {
      return e('div', {
        key: option.id,
        onClick: onClick,
        style: {
          padding: '24px',
          borderRadius: '12px',
          border: `2px solid ${isSelected ? colors.borderActive : colors.border}`,
          backgroundColor: isSelected ? 'rgba(215, 134, 80, 0.05)' : colors.cardBg,
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        },
        onMouseEnter: (e) => {
          if (!isSelected) e.currentTarget.style.borderColor = colors.borderHover;
        },
        onMouseLeave: (e) => {
          if (!isSelected) e.currentTarget.style.borderColor = colors.border;
        }
      },
        e('div', { style: { display: 'flex', alignItems: 'start', justifyContent: 'space-between', marginBottom: '12px' } },
          e('div', null,
            e('h3', { style: { fontSize: '18px', fontWeight: '600', color: colors.text, margin: '0 0 4px 0' } }, option.name),
            option.cores && e('p', { style: { fontSize: '14px', color: colors.primary, margin: '0 0 4px 0', fontWeight: '500' } }, option.cores),
            option.tier && e('p', { style: { fontSize: '14px', color: colors.primary, margin: '0 0 4px 0', fontWeight: '500' } }, option.tier),
            option.type && e('p', { style: { fontSize: '14px', color: colors.primary, margin: '0 0 4px 0', fontWeight: '500' } }, option.type),
            option.speed && e('p', { style: { fontSize: '14px', color: colors.primary, margin: '0 0 4px 0', fontWeight: '500' } }, option.speed)
          ),
          isSelected && e(Check, { width: '24', height: '24', style: { color: colors.primary } })
        ),
        e('p', { style: { fontSize: '14px', color: colors.textMuted, margin: '0 0 12px 0' } }, option.desc),
        showPrice && e('p', { style: { fontSize: '20px', fontWeight: '700', color: colors.text, margin: 0 } }, '$' + option.price)
      );
    };

    const stepKey = getCurrentStepKey();

return e('div', { style: { minHeight: '100vh', background: colors.bg, padding: '16px' } },
      e('div', { style: { maxWidth: '1200px', margin: '0 auto' } },
        e('div', { style: { textAlign: 'center', marginBottom: '48px', paddingTop: '32px' } },
            e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' } },
              e('div', { style: { background: 'white', borderRadius: '50%', padding: '8px', display: 'inline-block', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' } },
                e('img', { 
                  src: 'https://cdn.shopify.com/s/files/1/0715/7710/8573/files/1000104890.png',
                  alt: 'Cyborg Automation',
                  style: { height: '80px', width: 'auto', display: 'block' }
                })
              )
            ),
            e('h1', { style: { fontSize: '36px', fontWeight: '700', color: colors.text, marginBottom: '8px', margin: 0 } }, 'PC Builder Tool'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, margin: 0 } }, 'Configure your Media/Work/Gaming PC')
        ),
        
        e('div', { style: { marginBottom: '48px', overflowX: 'auto' } },
          e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 'max-content', padding: '0 8px' } },
            steps.map((step, idx) => {
              const Icon = step.icon;
              const isActive = currentStep === step.number;
              const isComplete = currentStep > step.number;
              
              return e(F, { key: step.number },
                e('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center' } },
                  e('div', { 
                    style: {
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '8px',
                      background: isComplete ? colors.success : isActive ? colors.primary : colors.cardBg,
                      border: `2px solid ${isComplete ? colors.success : isActive ? colors.primary : colors.border}`
                    }
                  },
                    isComplete ? e(Check, { width: '24', height: '24', style: { color: 'white' } }) : e(Icon, { style: { color: isActive ? 'white' : colors.textMuted } })
                  ),
                  e('span', { style: { fontSize: '12px', fontWeight: '600', textAlign: 'center', color: isActive ? colors.text : colors.textMuted } }, step.title)
                ),
                idx < steps.length - 1 && e('div', { 
                  style: {
                    flex: 1,
                    height: '2px',
                    margin: '24px 8px 0 8px',
                    minWidth: '20px',
                    borderRadius: '2px',
                    background: currentStep > step.number ? colors.success : colors.border
                  }
                })
              );
            })
          )
        ),
        
        e('div', { style: { background: colors.cardBg, borderRadius: '16px', padding: '32px', marginBottom: '24px', border: `1px solid ${colors.border}` } },
          
          stepKey === 'cpu' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Select Your Processor'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'The brain of your PC'),
            e('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' } },
              cpuOptions.map(cpu => renderOptionCard(cpu, config.cpu === cpu.id, () => setConfig({...config, cpu: cpu.id}), false))
            )
          ),

          stepKey === 'gpu' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Select Your Graphics Card'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'Powers your gaming experience'),
            e('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' } },
              gpuOptions.map(gpu => renderOptionCard(gpu, config.gpu === gpu.id, () => setConfig({...config, gpu: gpu.id}), false))
            )
          ),

          stepKey === 'ram' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Select Your Memory'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'More RAM = better multitasking'),
            e('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' } },
              ramOptions.map(ram => renderOptionCard(ram, config.ram === ram.id, () => setConfig({...config, ram: ram.id}), false))
            )
          ),

          stepKey === 'storage' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Select Your Storage'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'Choose one or more storage drives (multiple selections allowed)'),
            e('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' } },
              storageOptions.map(storage => renderOptionCard(storage, config.storage.includes(storage.id), () => toggleStorage(storage.id), false))
            )
          ),

          stepKey === 'case' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Select Your Case'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'Houses all your components'),
            e('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' } },
              caseOptions.map(caseItem => renderOptionCard(caseItem, config.case === caseItem.id, () => setConfig({...config, case: caseItem.id}), false))
            )
          ),

          stepKey === 'cooling' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Select Your CPU Cooling'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'The main CPU cooler. (All other fans are included)'),
            e('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' } },
              coolingOptions.map(cooling => renderOptionCard(cooling, config.cooling === cooling.id, () => setConfig({...config, cooling: cooling.id}), false))
            )
          ),

          stepKey === 'extras' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '8px', marginTop: 0 } }, 'Optional Extras'),
            e('p', { style: { fontSize: '16px', color: colors.textMuted, marginBottom: '32px', marginTop: 0 } }, 'Add optional extras or skip to continue'),
            
            e('div', { style: { padding: '24px', borderRadius: '12px', border: `2px solid ${config.wifi ? colors.borderActive : colors.border}`, backgroundColor: config.wifi ? 'rgba(215, 134, 80, 0.05)' : colors.cardBg, cursor: 'pointer', marginBottom: '16px' }, onClick: () => setConfig({...config, wifi: !config.wifi}) },
              e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                e('div', null,
                  e('h3', { style: { fontSize: '18px', fontWeight: '600', color: colors.text, margin: '0 0 4px 0' } }, 'WiFi 6 Adapter'),
                  e('p', { style: { fontSize: '14px', color: colors.textMuted, margin: '0 0 8px 0' } }, 'Wireless connectivity'),
                  e('p', { style: { fontSize: '20px', fontWeight: '700', color: colors.text, margin: 0 } }, '$59')
                ),
                config.wifi && e(Check, { width: '24', height: '24', style: { color: colors.primary } })
              )
            ),

            e('div', { style: { padding: '24px', borderRadius: '12px', border: `2px solid ${config.rgb ? colors.borderActive : colors.border}`, backgroundColor: config.rgb ? 'rgba(215, 134, 80, 0.05)' : colors.cardBg, cursor: 'pointer', marginBottom: '16px' }, onClick: () => setConfig({...config, rgb: !config.rgb}) },
              e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                e('div', null,
                  e('h3', { style: { fontSize: '18px', fontWeight: '600', color: colors.text, margin: '0 0 4px 0' } }, 'RGB Lighting Kit'),
                  e('p', { style: { fontSize: '14px', color: colors.textMuted, margin: '0 0 8px 0' } }, 'Customisable RGB fans and strips'),
                  e('p', { style: { fontSize: '20px', fontWeight: '700', color: colors.text, margin: 0 } }, '$159')
                ),
                config.rgb && e(Check, { width: '24', height: '24', style: { color: colors.primary } })
              )
            ),

            e('div', { style: { padding: '24px', borderRadius: '12px', border: `2px solid ${config.warranty ? colors.borderActive : colors.border}`, backgroundColor: config.warranty ? 'rgba(215, 134, 80, 0.05)' : colors.cardBg, cursor: 'pointer', marginBottom: '16px' }, onClick: () => setConfig({...config, warranty: !config.warranty}) },
              e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                e('div', null,
                  e('h3', { style: { fontSize: '18px', fontWeight: '600', color: colors.text, margin: '0 0 4px 0' } }, 'Extended Warranty (3 Years)'),
                  e('p', { style: { fontSize: '14px', color: colors.textMuted, margin: '0 0 8px 0' } }, 'Additional 2 years beyond standard warranty'),
                  e('p', { style: { fontSize: '20px', fontWeight: '700', color: colors.text, margin: 0 } }, '$399')
                ),
                config.warranty && e(Check, { width: '24', height: '24', style: { color: colors.primary } })
              )
            ),

            e('div', { style: { padding: '24px', borderRadius: '12px', border: `2px solid ${config.peripherals ? colors.borderActive : colors.border}`, backgroundColor: config.peripherals ? 'rgba(215, 134, 80, 0.05)' : colors.cardBg, cursor: 'pointer', marginBottom: '16px' }, onClick: () => setConfig({...config, peripherals: !config.peripherals}) },
              e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                e('div', null,
                  e('h3', { style: { fontSize: '18px', fontWeight: '600', color: colors.text, margin: '0 0 4px 0' } }, 'Gaming Keyboard & Mouse'),
                  e('p', { style: { fontSize: '14px', color: colors.textMuted, margin: '0 0 8px 0' } }, 'Mechanical keyboard with RGB mouse'),
                  e('p', { style: { fontSize: '20px', fontWeight: '700', color: colors.text, margin: 0 } }, '$259')
                ),
                config.peripherals && e(Check, { width: '24', height: '24', style: { color: colors.primary } })
              )
            ),

            e('div', { style: { padding: '24px', borderRadius: '12px', border: `2px solid ${config.os ? colors.borderActive : colors.border}`, backgroundColor: config.os ? 'rgba(215, 134, 80, 0.05)' : colors.cardBg, cursor: 'pointer' }, onClick: () => setConfig({...config, os: !config.os}) },
              e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                e('div', null,
                  e('h3', { style: { fontSize: '18px', fontWeight: '600', color: colors.text, margin: '0 0 4px 0' } }, 'Windows 11 Home (Included)'),
                  e('p', { style: { fontSize: '14px', color: colors.textMuted, margin: '0 0 8px 0' } }, 'Pre-installed and activated'),
                  e('p', { style: { fontSize: '20px', fontWeight: '700', color: colors.text, margin: 0 } }, 'Included')
                ),
                e(Check, { width: '24', height: '24', style: { color: colors.primary } })
              )
            )
          ),

          stepKey === 'review' && e('div', null,
            e('h2', { style: { fontSize: '28px', fontWeight: '700', color: colors.text, marginBottom: '32px', marginTop: 0 } }, 'Review Your Build'),
            e('div', { style: { background: colors.bg, borderRadius: '12px', padding: '24px', marginBottom: '24px' } },
              e('h3', { style: { fontSize: '20px', fontWeight: '600', color: colors.text, marginBottom: '16px', marginTop: 0 } }, 'Selected Components'),
              e('div', { style: { display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '15px', color: colors.textLight } },
                config.cpu && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'CPU:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, cpuOptions.find(c => c.id === config.cpu)?.name)
                ),
                config.gpu && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'GPU:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, gpuOptions.find(g => g.id === config.gpu)?.name)
                ),
                config.ram && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'RAM:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, ramOptions.find(r => r.id === config.ram)?.name)
                ),
                config.storage.length > 0 && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Storage:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, 
                    config.storage.map(id => storageOptions.find(s => s.id === id)?.name).join(', ')
                  )
                ),
                getMotherboard() && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Motherboard:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, getMotherboard().name)
                ),
                getPSU() && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Power Supply:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, getPSU().name)
                ),
                config.case && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Case:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, caseOptions.find(c => c.id === config.case)?.name)
                ),
                config.cooling && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Cooling:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, coolingOptions.find(c => c.id === config.cooling)?.name)
                ),
                config.wifi && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'WiFi:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, 'WiFi 6 Adapter')
                ),
                config.rgb && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'RGB Lighting:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, 'RGB Lighting Kit')
                ),
                config.warranty && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Warranty:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, 'Extended Warranty (3 Years)')
                ),
                config.peripherals && e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Peripherals:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, 'Gaming Keyboard & Mouse')
                ),
                e('div', { style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '8px', borderBottom: `1px solid ${colors.border}` } },
                  e('span', null, 'Operating System:'),
                  e('span', { style: { fontWeight: '600', color: colors.text } }, 'Windows 11 Home')
                ),
                e('div', { style: { paddingTop: '16px', marginTop: '8px', borderTop: `2px solid ${colors.border}` } },
                  e('div', { style: { display: 'flex', justifyContent: 'space-between', fontSize: '24px', fontWeight: '700' } },
                    e('span', { style: { color: colors.text } }, 'Total:'),
                    e('span', { style: { color: colors.primary } }, '$' + calculateTotal())
                  ),
                  e('p', { style: { fontSize: '13px', color: colors.textMuted, marginTop: '8px', marginBottom: 0 } }, 'All prices include assembly and delivery service. Windows 11 included.')
                )
              )
            )
          ),

          currentStep >= 8 && e('div', { style: { background: colors.cardBg, borderRadius: '16px', padding: '24px', marginBottom: '24px', border: `1px solid ${colors.border}` } },
          e('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' } },
            e('div', null,
              e('p', { style: { fontSize: '14px', color: colors.textMuted, marginBottom: '4px', marginTop: 0 } }, 'Total Build Cost'),
              e('p', { style: { fontSize: '32px', fontWeight: '700', color: colors.text, margin: 0 } }, '$' + calculateTotal())
            ),
            e('div', { style: { textAlign: 'right' } },
              e('p', { style: { fontSize: '13px', color: colors.textMuted, margin: 0 } }, 'Ready to build')
            )
          )
        ),
        
        e('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', marginTop: '24px' } },
          e('button', {
            onClick: handleBack,
            disabled: currentStep === 1,
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '16px',
              cursor: currentStep === 1 ? 'not-allowed' : 'pointer',
              border: 'none',
              background: currentStep === 1 ? colors.border : colors.cardBg,
              color: currentStep === 1 ? colors.textMuted : colors.text
            }
          },
            e(ChevronLeft),
            'Back'
          ),
          
          currentStep < steps.length
            ? e('button', {
                onClick: handleNext,
                disabled: !canProceed(),
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 32px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '16px',
                  cursor: canProceed() ? 'pointer' : 'not-allowed',
                  border: 'none',
                  background: canProceed() ? colors.primary : colors.border,
                  color: canProceed() ? 'white' : colors.textMuted
                }
              },
                'Next',
                e(ChevronRight)
              )
            : e('button', {
                disabled: !canProceed(),
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 32px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '16px',
                  cursor: canProceed() ? 'pointer' : 'not-allowed',
                  border: 'none',
                  background: canProceed() ? colors.success : colors.border,
                  color: canProceed() ? 'white' : colors.textMuted
                },
                onClick: async () => {
                  if (!canProceed()) return;

                  const components = [];
                  
                  if (config.cpu) {
                    const cpu = cpuOptions.find(c => c.id === config.cpu);
                    components.push(cpu.name);
                  }
                  if (config.gpu) {
                    const gpu = gpuOptions.find(g => g.id === config.gpu);
                    components.push(gpu.name);
                  }
                  if (config.ram) {
                    const ram = ramOptions.find(r => r.id === config.ram);
                    components.push(ram.name);
                  }
                  
                  config.storage.forEach(storageId => {
                    const storage = storageOptions.find(s => s.id === storageId);
                    if (storage) components.push(storage.name);
                  });
                  
                  const mobo = getMotherboard();
                  if (mobo) components.push(mobo.name);
                  
                  const psu = getPSU();
                  if (psu) components.push(psu.name);
                  
                  if (config.case) {
                    const caseItem = caseOptions.find(c => c.id === config.case);
                    components.push(caseItem.name);
                  }
                  if (config.cooling) {
                    const cooling = coolingOptions.find(c => c.id === config.cooling);
                    components.push(cooling.name);
                  }
                  if (config.wifi) components.push('WiFi 6 PCI-E Adapter');
                  if (config.rgb) components.push('RGB Lighting Kit');
                  if (config.warranty) components.push('Extended Warranty (3 Years)');
                  if (config.peripherals) components.push('Gaming Keyboard & Mouse');
                  
                  components.push('Windows 11 Home');

                  const properties = {
                    'Components': components.join(' | ')
                  };

                  try {
                    const total = calculateTotal();
                    
                    const updatePriceResponse = await fetch('https://shopify-configurator-server.vercel.app/apps/configurator/update-variant-price', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        variant_id: 43888668082269,
                        price: total.toString()
                      })
                    });
                    
                    if (!updatePriceResponse.ok) {
                      throw new Error('Failed to update price');
                    }
                    
                    const formData = {
                      items: [{
                        id: 43888668082269,
                        quantity: 1,
                        properties: properties
                      }]
                    };
                    
                    const response = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(formData)
                    });
                    
                    const data = await response.json();
                    
                    if (response.ok) {
                      window.location.href = '/cart';
                    } else {
                      throw new Error(data.description || 'Failed to add to cart');
                    }
                  } catch (err) {
                    alert('Error adding to cart. Please try again.\n\nError: ' + err.message);
                  }
                }
              },
              e(Check),
              'Add to Cart'
            )
        )
      )
    )
  );
  };

  const rootElement = document.getElementById('pc-builder-root');
  console.log('Root element:', rootElement);
  if (rootElement) {
    console.log('Creating React root and rendering...');
    const root = ReactDOM.createRoot(rootElement);
    root.render(e(PCBuilder));
    console.log('Render called!');
  } else {
    console.error('pc-builder-root element not found!');
  }
}

// Start initialization
console.log('PC Builder script loaded, readyState:', document.readyState);
if (document.readyState === 'loading') {
  console.log('Waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', initPCBuilder);
} else {
  console.log('DOM already loaded, initializing now...');
  initPCBuilder();
}
})();